import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import useLocationSearchParams from '../../hooks/useLocationSearchParams';
import usePhysicianInvitations from '../hooks/usePhysicianInvitations';

const PhysicianInvitationCodeModule = ({ permanentInvitationId }) => {
  const [hasError, setHasError] = useState(false);
  const { invitationId } = useLocationSearchParams();
  const { redeemed: contact, redeem } = usePhysicianInvitations();
  const history = useHistory();

  useEffect(() => {
    if (invitationId || permanentInvitationId) {
      (async () => {
        try {
          await redeem({ id: permanentInvitationId || invitationId });
        } catch (e) {
          setHasError(e);
        }
      })();
    } else {
      history.replace('/chat');
    }
  }, [invitationId, permanentInvitationId]);

  useEffect(() => {
    if (contact.id) history.replace('/');
  }, [contact.id]);

  useEffect(() => {
    if (contact.notFound || contact.isSelf || hasError) setTimeout(() => history.replace('/chat'));
  }, [contact.notFound, contact.isSelf, hasError]);

  return null;
};

PhysicianInvitationCodeModule.propTypes = {
  permanentInvitationId: PropTypes.string,
};

export default PhysicianInvitationCodeModule;
